<template>
	<div @click.self="$emit('close')" class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-40">
		<div class="popup-bg rounded-2xl p-6 w-10/12 md:w-3/6 lg:w-1/3 xl:w-2/5 animate-scale-in shadow-2xl relative" >
			<button @click="$emit('close')" class="absolute top-4 right-4 p-2 rounded-full transition" >
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close" class="w-4 h-4" />
			</button>

			<h2 class="text-2xl font-archivosemibold mb-4 text-[var(--text-color)] text-center"> 
				Address Book
			</h2>

			<div class="max-h-52 overflow-y-auto mb-4 space-y-2">
				<div v-if="addressBook.length">
					<div v-for="entry in addressBook" :key="entry.address" @click="$emit('select-entry', entry)" class="flex justify-between items-center my-1 border border-[var(--accent-color)] p-3 bg-[var(--balance-bg-color)] rounded-lg cursor-pointer hover:bg-[var(--accent-color)] text-[var(--address-popup-text-color)] transition">
						<div class="flex flex-col">
							<span class="font-archivosemibold">
								{{ entry.name }}
							</span>
							<span class="text-xs font-archivolight break-all">
								{{ entry.address }}
							</span>
						</div>
						<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
						</svg>
					</div>
				</div>

				<p v-else class="text-center my-2 italic font-archivolight text-[var(--secondary-text-color)]">
					No addresses found. You can add one below :)
				</p>
			</div>

			<hr class="horizontal-line-bg mb-4" />

			<div>
				<div v-if="addressBook.length === 0 || addingContact">
					<h3 class="text-xl font-archivomedium mb-3 text-[var(--text-color)] text-center">
						Add Contact
					</h3>

					<div class="space-y-4">
						<div>
							<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]">
								Name
							</label>
							<input :value="newContactName" @input="$emit('update:newContactName', $event.target.value)" type="text" placeholder="Alice" class="w-full px-4 py-2 rounded-lg bg-[var(--dropdown-bg-color)] text-[var(--address-popup-text-color)] focus:outline-none shadow-inner"/>
						</div>

						<div>
							<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]">
								Address
							</label>
							<input :value="newContactAddress" @input="$emit('update:newContactAddress', $event.target.value)" type="text" placeholder="0x…" class="w-full px-4 py-2 rounded-lg bg-[var(--dropdown-bg-color)] text-[var(--address-popup-text-color)] focus:outline-none shadow-inner"/>
						</div>

						<button @click="$emit('add-address')" class="w-full py-2 bg-[var(--accent-color)] text-[var(--hover-text-color)] font-archivoregular rounded-full shadow-inner hover:bg-transparent hover:text-[var(--accent-color)] border border-[var(--accent-color)] transition">
							Save
						</button>
					</div>
				</div>

				<div v-else>
					<button @click="$emit('start-add')" class="flex items-center justify-center space-x-2 w-full py-2 bg-[var(--accent-color)] text-[var(--hover-text-color)] font-archivoregular rounded-full shadow-md hover:shadow-lg transition">
						<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" >
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
						</svg>
						<span>
							Add Contact
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, watch } from 'vue';
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		addressBook: { type: Array,  required: true },
		addingContact: { type: Boolean, required: true },
		newContactName: { type: String, required: true },
		newContactAddress: { type: String, required: true }
	});

	const emit = defineEmits([
		'close',
		'select-entry',
		'start-add',
		'update:newContactName',
		'update:newContactAddress',
		'add-address'
	]);
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}
</style>

